
import dayjs from 'dayjs'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import TableCellView from 'frame/components/table-cell/table-cell'
import { types } from '../../module'

const formatDate = (value) => {
  if (!value) {
    return '-'
  }

  const parsed = dayjs(value)
  return parsed.isValid() ? parsed.format('DD/MM/YY') : '-'
}

const formatValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  return value
}

const formatTimeSinceLastReading = (value, lastReadingDate) => {
  if (value !== null && value !== undefined) {
    return `${value} days`
  }

  if (!lastReadingDate) {
    return '-'
  }

  const parsed = dayjs(lastReadingDate)
  if (!parsed.isValid()) {
    return '-'
  }

  const days = dayjs().startOf('day')
    .diff(parsed.startOf('day'), 'day')
  return `${days} days`
}

const Row = ({ item, columns }) => (
  <TableRow
    hover
    sx={{
      boxSizing: 'border-box',
      verticalAlign: 'middle',
      height: '30px',
      borderBottom: '5px solid white',
    }}>
    <TableCell sx={{ bgcolor: 'white', width: '10px', p: 0 }} />
    {columns.thirdPartyNumber && (
      <TableCellView isFirst>
        {formatValue(item.thirdPartyNumber)}
      </TableCellView>
    )}
    {columns.customerName && (
      <TableCellView>
        {formatValue(item.customerName)}
      </TableCellView>
    )}
    {columns.vehicleRegistration && (
      <TableCellView>
        {formatValue(item.vehicleRegistration)}
      </TableCellView>
    )}
    {columns.driver && (
      <TableCellView>
        {formatValue(item.driver)}
      </TableCellView>
    )}
    {columns.driverEmail && (
      <TableCellView>
        {formatValue(item.driverEmail)}
      </TableCellView>
    )}
    {columns.driverMobile && (
      <TableCellView>
        {formatValue(item.driverMobile)}
      </TableCellView>
    )}
    {columns.lastReadingDate && (
      <TableCellView>
        {formatDate(item.lastReadingDate)}
      </TableCellView>
    )}
    {columns.datasource && (
      <TableCellView>
        {formatValue(item.datasource)}
      </TableCellView>
    )}
    {columns.odometer && (
      <TableCellView>
        {formatValue(item.odometer)}
      </TableCellView>
    )}
    {columns.timeSinceLastReading && (
      <TableCellView>
        {formatTimeSinceLastReading(item.timeSinceLastReading, item.lastReadingDate)}
      </TableCellView>
    )}
    {columns.costCentre && (
      <TableCellView>
        {formatValue(item.costCentre)}
      </TableCellView>
    )}
    {columns.fleetController && (
      <TableCellView>
        {formatValue(item.fleetController)}
      </TableCellView>
    )}
    {Object.values(columns).some((value) => value === true) && (
      <TableCellView isLast></TableCellView>
    )}
  </TableRow>
)

Row.propTypes = {
  item: types.ModelType.isRequired,
  columns: types.ColumnsType.isRequired,
}

export default Row
